"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotspotsFloatElement = void 0;
const float_element_1 = require("../../components/float-element/float-element");
class HotspotsFloatElement extends float_element_1.FloatElement {
}
exports.HotspotsFloatElement = HotspotsFloatElement;
